module.exports = __webpack_public_path__ + "static/media/1014788.901784b0.jpg";